import { render, staticRenderFns } from "./editStudent.vue?vue&type=template&id=31390e9c"
import script from "./editStudent.vue?vue&type=script&lang=js"
export * from "./editStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports